export { default as autoCreditTableColumns } from './table-columns';
